import { Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';

const CustomCookieBanner = ({ onAccept, onDecline }) => (
    <Dialog
        open={true}
        maxWidth='sm'
        fullWidth
        disableEscapeKeyDown
        onClose={(_, reason) => {
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return;
            }
        }}>
        <DialogTitle
            sx={{
                m: 0,
                p: 2,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
            }}>
            <CookieIcon sx={{ fontSize: 32, ml: 2 }} />
            <Typography variant='h5' component='div'>
                Cookie Consent
            </Typography>
        </DialogTitle>
        <DialogContent dividers>
            <Typography variant='body1' sx={{ textAlign: 'center', my: 3 }}>
                We use cookies to enhance your browsing experience and analyze our traffic. By clicking "Accept", you
                consent to our use of cookies.
            </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: 2, justifyContent: 'flex-end' }}>
            <Button onClick={onDecline} variant='outlined' size='large'>
                Decline
            </Button>
            <Button onClick={onAccept} variant='contained' size='large' autoFocus>
                Accept
            </Button>
        </DialogActions>
    </Dialog>
);

export default CustomCookieBanner;
